import Fetch from "utils/fetch";

export const searchTimelineByOrder = (idPedido, user) => {
  return Fetch.get(`timeline/consultanegociacoesporpedido/${idPedido}/${user}`).then(({ data }) => data)
}

export const searchTimelineByVolumeOrder = (idPedido, user) => {
  return Fetch.get(`/timeline/consultaNegociacoesPorVolume/${idPedido}/${user}`).then(({ data }) => data)
}
